import React, { Component } from "react";
import AdvancedCommonFileSettings from "./AdvancedCommonFileSettings";

export class AdvancedDriveSettings extends Component {
  state = {
    readerSharedDrivesInclude: [],
    readerSharedDrivesExclude: [],
    spiderSharedDrivesInclude: [],
    spiderSharedDrivesExclude: [],
    childSettings: {
      spiderDoNotSpiderUrl: [],
      spiderOnlySpiderUrl: [],
      spiderDoNotReadUrl: [],
      spiderOnlyReadUrl: [],
      onlyReadContentType: [],
      doNotReadContentType: [],
    },
  };

  componentDidMount() {
    this.settingsUpdated();
    this.parseEditKs();
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state !== prevState) {
      this.settingsUpdated();
    }
    if (this.props.editKs !== prevProps.editKs) {
      this.parseEditKs();
    }
  }

  parseEditKs = () => {
    if (this.props.editKs && Object.keys(this.props.editKs).length > 0) {
      let onlyReadRegexes = {
        onlyReadSharedDrives: this.props.editKs.spiderProperties
          .readerSharedDrivesInclude,
      };
      let doNotReadRegexes = {
        doNotReadSharedDrives: this.props.editKs.spiderProperties
          .readerSharedDrivesExclude,
      };
      let doNotSpiderRegexes = {
        doNotSpiderSharedDrives: this.props.editKs.spiderProperties
          .spiderSharedDrivesExclude,
      };
      this.onOnlyReadUpdate(onlyReadRegexes);
      this.onDoNotReadUpdate(doNotReadRegexes);
      this.onDoNotSpiderUpdate(doNotSpiderRegexes);
    }
  };

  render() {
    return (
      <div>
        <AdvancedCommonFileSettings
          editKs={this.props.editKs}
          setSpiderProperties={this.setChildSettings}
          sourceType="GOOGLE_DRIVE"
          onOnlyReadUpdate={this.onOnlyReadUpdate}
          onDoNotReadUpdate={this.onDoNotReadUpdate}
          onDoNotSpiderUpdate={this.onDoNotSpiderUpdate}
        />
      </div>
    );
  }

  onOnlyReadUpdate = (regexes) => {
    let { onlyReadSharedDrives, ...unknown } = regexes;

    this.setState({ readerSharedDrivesInclude: onlyReadSharedDrives });

    if (this.props.onOnlyReadUpdate) {
      this.props.onOnlyReadUpdate(unknown);
    }
  };

  onDoNotReadUpdate = (regexes) => {
    let { doNotReadSharedDrives, ...unknown } = regexes;

    this.setState({ readerSharedDrivesExclude: doNotReadSharedDrives });
    if (this.props.onDoNotReadUpdate) {
      this.props.onDoNotReadUpdate(unknown);
    }
  };

  onDoNotSpiderUpdate = (regexes) => {
    let { doNotSpiderSharedDrives, ...unknown } = regexes;

    this.setState({ spiderSharedDrivesExclude: doNotSpiderSharedDrives });
    if (this.props.onDoNotSpiderUpdate) {
      this.props.onDoNotSpiderUpdate(unknown);
    }
  };

  settingsUpdated = () => {
    this.props.setSpiderProperties({
      ...this.state.childSettings,
      readerSharedDrivesExclude: this.state.readerSharedDrivesExclude,
      readerSharedDrivesInclude: this.state.readerSharedDrivesInclude,
      spiderSharedDrivesExclude: this.state.spiderSharedDrivesExclude,
    });
  };

  setChildSettings = (childSettings) => {
    this.setState({ childSettings });
  };
}

export default AdvancedDriveSettings;
